import type { CreditBlotterExposure, MobileCardRendererProps, MobileGroupCardRendererProps } from '@talos/kyoko';
import type { ReactNode } from 'react';
import {
  CREDIT_EXPOSURE_COL_ID,
  CREDIT_REMAINING_CREDIT_COL_ID,
  CREDIT_USAGE_COL_ID,
  VISIBLE_COLUMN_RENDER_OPTIONS,
} from './mobileCreditColumns';

export interface CreditMetric {
  colId: string;
  label: string;
  value: ReactNode;
  testId: string;
}

export function getRequiredCreditMetrics(
  renderCell: MobileCardRendererProps<CreditBlotterExposure>['renderCell']
): [CreditMetric, CreditMetric, CreditMetric] {
  return [
    {
      colId: CREDIT_EXPOSURE_COL_ID,
      label: 'Exposure',
      value: renderCell(CREDIT_EXPOSURE_COL_ID, VISIBLE_COLUMN_RENDER_OPTIONS),
      testId: 'mobile-credit-card-exposure',
    },
    {
      colId: CREDIT_REMAINING_CREDIT_COL_ID,
      label: 'Remaining Credit',
      value: renderCell(CREDIT_REMAINING_CREDIT_COL_ID, VISIBLE_COLUMN_RENDER_OPTIONS),
      testId: 'mobile-credit-card-remaining-credit',
    },
    {
      colId: CREDIT_USAGE_COL_ID,
      label: 'Credit Usage',
      value: renderCell(CREDIT_USAGE_COL_ID, VISIBLE_COLUMN_RENDER_OPTIONS),
      testId: 'mobile-credit-card-credit-usage',
    },
  ];
}

export function getCreditGroupExposureMetric(
  renderCell: MobileGroupCardRendererProps<CreditBlotterExposure>['renderCell']
): CreditMetric {
  return {
    colId: CREDIT_EXPOSURE_COL_ID,
    label: 'Exposure',
    value: renderCell(CREDIT_EXPOSURE_COL_ID, VISIBLE_COLUMN_RENDER_OPTIONS),
    testId: 'mobile-credit-group-card-exposure',
  };
}
